module.exports = __webpack_public_path__ + "img/icon_map_huanjingjiankong_lixian.54b65b98.svg";